import { render, staticRenderFns } from "./ClaioSchemaAdapter.vue?vue&type=template&id=74a208ef&scoped=true&"
import script from "./ClaioSchemaAdapter.vue?vue&type=script&lang=ts&"
export * from "./ClaioSchemaAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a208ef",
  null
  
)

export default component.exports